import React from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { LinkRegion } from '@sparknz/tracking';

import { FormData } from 'journey/checkout/types';
import { StoreItemViewModel } from 'shared/types/store';
import { AvailabilityText, StoreList } from './components';
import StoreListWithRadio from './components/StoreList/StoreListWithRadio';

type StoreListSectionProps = {
  stores: StoreItemViewModel[];
  setInfoLayerOpen: (open: boolean) => void;
  setSelectedStore: (store: StoreItemViewModel) => void;
  availability: number;
  displayRadio: boolean;
  field?: ControllerRenderProps<FormData, string>;
};

const StoreListSection = ({
  stores,
  setSelectedStore,
  setInfoLayerOpen,
  availability,
  displayRadio = true,
  field,
}: StoreListSectionProps) => {
  return (
    <div
      data-testid={
        displayRadio
          ? 'store_list_component'
          : 'store_list_for_one_offerId_component'
      }
    >
      <AvailabilityText availability={availability} />
      <LinkRegion regionId="delivery.findYourNearestStore">
        {displayRadio ? (
          <StoreListWithRadio
            field={field}
            stores={stores}
            setSelectedStore={setSelectedStore}
            setInfoLayerOpen={setInfoLayerOpen}
          />
        ) : (
          <StoreList
            stores={stores}
            setSelectedStore={setSelectedStore}
            setInfoLayerOpen={setInfoLayerOpen}
          />
        )}
      </LinkRegion>
    </div>
  );
};

export default StoreListSection;
